export class NovedadApp {
  idNovedad: number;
  descNovedad: string;
  rutaImagen: string;
  aprobada: boolean;
}
